import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Img from 'components/common/Img';

class Gallery extends Component {
	constructor(props) {
		super(props);
		const cover = props.items[0];
		this.bound = { width: cover.width, height: cover.height };
		this.ratio = (this.bound.height / this.bound.width);
		this.timer = null;
		this.state = { index: 0 }
		this.gallery = React.createRef();
	}
	componentDidMount() {
		setTimeout( () => {
			const hovering = this.gallery.current.matches(':hover');
			if (hovering) this.startAutoplay();
		});
	}
	componentWillUnmount() {
		this.stopAutoplay();
	}
	next = () => {
		const index = (this.state.index < this.props.items.length-1)? this.state.index + 1 : 0;
		this.setState({ index: index });
		this.timer = setTimeout( this.next, this.props.speed );
	}
	startAutoplay = () => {
		clearTimeout( this.timer );
		this.next();
	}
	stopAutoplay = () => {
		clearTimeout( this.timer );
		this.timer = null;
	}
	stopAndReset = () => {
		this.stopAutoplay();
		this.setState({ index: 0 });
	}
	getThumbStyle(item, bound_ratio, index, active_index, length) {
		const indexDelta = index - active_index;
		const zIndex = (indexDelta > 0)? indexDelta : indexDelta + length;
		const itemRatio = item.height / item.width;
		let style = { display: 'block', position:'absolute', zIndex: zIndex, top: 0, left: 0 };
		style.visibility = ( index === active_index )? 'inherit' : 'hidden';
		style = ( itemRatio >= bound_ratio )
			? { ...style, width: (bound_ratio / itemRatio * 100) + '%', height: '100%' }      // fit height
			: { ...style, width: '100%', height: 0, paddingBottom: (itemRatio * 100) + '%' }; // fit weight

		return style;
	}
	render() {
		if ( !this.props.items ) return null;
		
		const length = this.props.items.length;
		const images = this.props.items.map( (item, index) => {
			const thumbStyle = this.getThumbStyle( item, this.ratio, index, this.state.index, length );
			const imgStyle = { display: 'block', width: '100%', height: 'auto' }
			return (
				<div key={index} style={thumbStyle}>
					<Img src={item.src} alt={item.alt} width={item.width} height={item.height} style={imgStyle} />
				</div>
			)
		} );
		const galleryStyle = {
			position: 'relative', height: 0,
			paddingBottom: this.ratio * 100 + '%',
			overflow: 'hidden'
		};
		let listeners = {};
		listeners.onMouseEnter = this.startAutoplay;
		listeners.onMouseLeave = this.stopAndReset;
		if ( this.props.enableTouch ) {
			listeners.onTouchStart = this.startAutoplay;
			listeners.onTouchEnd = this.stopAndReset;
		}
		return (
			<div className="Gallery" 
				ref={this.gallery} 
				style={galleryStyle}
				{...listeners}>
				{images}
			</div>
		)
	}
}
Gallery.propTypes = {
	items: PropTypes.array,
	speed: PropTypes.number,
	enableTouch: PropTypes.bool,
}
Gallery.defaultProps = {
	enableTouch: false
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/Pages/Home/Gallery.jsx